import { OneTimePricing } from "../../../ChoosePlanCarePlus/pricing";
import { CarePlusRadio } from "../../../CarePlusShared/carePlusUi";
import * as translator from "../../../../utils/translator";

interface Props {
  language: string;
  country: string;
  currencyRate?: number;
  pricing: OneTimePricing;
  isSelected: boolean;
  onSelect: () => void;
}

/** Figma 38938:681. */
const ReorderOneTimeOptionCard = ({ language, country, currencyRate = 1, pricing, isSelected, onSelect }: Props) => {
  const text = (key: string) => translator.translate(language, "reorder", `WlReorder/${key}`);
  const price = (amount: number) => translator.getPrice(amount, `${language.toLowerCase()}-${country.toUpperCase()}`, currencyRate);

  return (
    <div
      data-testid="wl-reorder-one-time-card"
      role="radio"
      aria-checked={isSelected}
      onClick={onSelect}
      className={`flex min-h-[97px] w-full cursor-pointer items-start justify-between rounded-[16px] border border-solid bg-white p-[16px] ${
        isSelected ? "border-[#f59603]" : "border-[#e2e8df]"
      }`}
    >
      <span className="flex min-w-0 items-start gap-[8px]">
        <CarePlusRadio checked={isSelected} />
        <span className="flex min-w-0 flex-col">
          <span className="font-poppins text-[16px] font-semibold leading-[24px] text-[#08080a]">{text("one_time_title")}</span>
          <span className="flex flex-col pt-[2px] font-roboto text-[12px] leading-[16px] text-[#a2a2a2]">
            <span>{text("one_time_subtitle")}</span>
            <span>{text("one_time_subtitle_2")}</span>
          </span>
        </span>
      </span>
      <span className="flex shrink-0 flex-col items-end">
        <span data-testid="wl-reorder-one-time-total" className="font-poppins text-[20px] font-medium leading-[25px] text-[#08080a]">
          {price(pricing.oneTimeChargedPrice)}
        </span>
        {pricing.hasOneTimeDiscount && (
          <span className="font-roboto text-[12px] leading-[16px] text-[#b1b1b1] line-through">{price(pricing.oneTimePrice)}</span>
        )}
      </span>
    </div>
  );
};

export default ReorderOneTimeOptionCard;
